<template>
  <div id="app">
    <el-backtop></el-backtop>

    <HeadNav class="global-header"></HeadNav>

    <div class="main-container">
      <router-view />
    </div>

    <BottomNav></BottomNav>
  </div>
</template>

<script>
import BottomNav from "./views/BottomNav.vue";
import HeadNav from "./views/HeadNav.vue";

export default {
  name: "App",
  components: {
    BottomNav,
    HeadNav,
  },
};
</script>

<style>
/* 1. 修正原代码的错误：原代码写的是 .app，但模板中是 id="app"。
  必须要让 html, body, #app 在移动端和PC端拥有一致的基准。
*/
html,
body {
  margin: 0;
  padding: 0;
  width: 100%;
  /* 解决旧版安卓/微信内置浏览器因内容异步加载导致的局部闪烁问题 */
  -webkit-text-size-adjust: 100%;
}

#app {
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333333; /* 建议全局使用深色字，特定板块（如页脚）再单独用白字 */
  width: 100%;
  overflow-x: hidden; /* 极其重要：彻底防止移动端因为某些特殊元素溢出导致的横向左右晃动 */
}

/* ==================== PC 端默认样式 ==================== */
.global-header {
  position: absolute;
  top: 0;
  left: 0;
  background: transparent; /* PC端保持透明悬浮在首屏大图上 */
}

.main-container {
  width: 100%;
  min-height: calc(
    100vh - 70px
  ); /* 保证内容区至少撑满一屏，防止页脚大面积白屏悬空 */
}

/* ==================== 📱 移动端自适应兼容样式 ==================== */
@media screen and (max-width: 991px) {
  .global-header {
    position: fixed !important; /* 强制覆盖，手机端必须是固定顶部，跟着屏幕走 */
    top: 0;
    left: 0;
    width: 100%;
    background: #17213d !important; /* 手机端必须给实体底色，否则下滑时内容重叠成浆糊 */
    z-index: 2000 !important; /* 确保层级高于 Element UI 的普通组件 */
  }

  .main-container {
    /* 致命兼容细节：因为手机端导航栏变成了 fixed（固定在顶部 60px 高度），
      如果不给内容容器加一个 60px 的顶部内边距，
      所有子页面（首页视频、最新资讯、关于我们）的最顶部内容，都会被导航栏生硬地挡住！
    */
    padding-top: 60px;
    box-sizing: border-box;
    min-height: calc(100vh - 60px);
  }
}
</style>
